import React, { Component } from 'react';
import { number } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { DEFAULT_BG_INDEX, HERO_IMAGES } from '../../utils/hero/constants';
import { LOHP_ROW, MAX_WIDTH_CONTAINER } from '../../utils/constants';
import SafeComponent from '../shared/SafeComponent';
import { HERO_ROTATION_INTERVAL } from './constants';
import Header from './Header';

import './style.scss';

class Hero extends Component {

    constructor(props) {
        super(props);

        const { bgIndex } = this.props;

        this.state = {
            backgroundIndex: bgIndex
        };

        this.changeBackground = this.changeBackground.bind(this);
    }

    componentDidMount() {
        this.rotateHeroes();
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    /* When the user scales down the screen, we don't want the bg color to change */
    get fixedBackground() {
        const { bgIndex } = this.props;

        const fixedIndex = bgIndex < HERO_IMAGES.length
            ? bgIndex
            : DEFAULT_BG_INDEX;

        return HERO_IMAGES[fixedIndex].className;
    }

    rotateHeroes() {
        this.interval = setInterval(
            this.changeBackground,
            HERO_ROTATION_INTERVAL
        );
    }

    changeBackground() {
        const { backgroundIndex } = this.state;
        const nextBackgroundIndex = (backgroundIndex + 1) % HERO_IMAGES.length;

        this.setState({
            backgroundIndex: nextBackgroundIndex
        });
    }

    render() {
        const { backgroundIndex } = this.state;

        const heroWrapperClasses = classNames(
            'hero-wrapper',
            'm-b-0',
            this.fixedBackground,
            LOHP_ROW
        );

        const heroClasses = classNames(
            'hero',
            MAX_WIDTH_CONTAINER
        );

        return (
            <div className={heroWrapperClasses}>
                <div className="hero-backgrounds">
                    {
                        HERO_IMAGES.map((heroImage, index) => {
                            const style = { opacity: index === backgroundIndex ? '1' : '0' };
                            const heroTitleKey = `logged_out_homepage.hero.${heroImage.title}`;
                            const sellerNameClasses = classNames(
                                'seller-name',
                                MAX_WIDTH_CONTAINER,
                                { 'show-stars': heroImage.showStars }
                            );

                            return (
                                <div className={heroImage.className} key={index} style={style}>
                                    <div className={sellerNameClasses}>
                                        <p>{heroImage.name}, <b><I18n k={heroTitleKey}/></b></p>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className={heroClasses}>
                    <Header/>
                </div>
            </div>
        );
    }

}

Hero.defaultProps = {
    bgIndex: DEFAULT_BG_INDEX
};

Hero.propTypes = {
    bgIndex: number
};

export { Hero };
export default SafeComponent(Hero);
